import { UnreachableError } from 'base/helpers';
import {
  AcceptPlanDialogUrlState,
  parseAcceptPlanDialogUrlState,
  serializeAcceptPlanDialogUrlState,
} from 'blocks/auth/accept_plan_offer';

export type ManageAccountRoute =
  | {
      path: 'manage-account';
    }
  | {
      path: 'manage-account/plan';
      dialog?: AcceptPlanDialogUrlState;
    }
  | {
      path: 'manage-account/team';
      showInviteNewUsers?: boolean;
    }
  | {
      path: 'manage-account/referral';
    };

export function maybeParseManageAccountRoute(
  url: Pick<URL, 'searchParams' | 'pathname'>,
): ManageAccountRoute | undefined {
  if (url.pathname === '/app/manage-account') {
    return { path: 'manage-account' };
  }
  if (url.pathname === '/app/manage-account/plan') {
    return {
      path: 'manage-account/plan',
      dialog: parseAcceptPlanDialogUrlState(url.searchParams),
    };
  }
  if (url.pathname === '/app/manage-account/referral') {
    return {
      path: 'manage-account/referral',
    };
  }
  if (url.pathname === '/app/manage-account/team') {
    return {
      path: 'manage-account/team',
      showInviteNewUsers:
        url.searchParams.get('invite-users') === 'true' ?? undefined,
    };
  }
}

export function manageAccountRouteToUrl(route: ManageAccountRoute) {
  switch (route.path) {
    case 'manage-account': {
      return '/app/manage-account';
    }
    case 'manage-account/referral': {
      return '/app/manage-account/referral';
    }
    case 'manage-account/plan': {
      const search = new URLSearchParams();
      serializeAcceptPlanDialogUrlState(route.dialog, search);
      return `/app/manage-account/plan?${search}`;
    }
    case 'manage-account/team': {
      const search = route.showInviteNewUsers
        ? `?${new URLSearchParams({
            'invite-users': 'true',
          }).toString()}`
        : '';

      return `/app/manage-account/team${search}`;
    }

    default: {
      throw new UnreachableError(route);
    }
  }
}
